import { render, staticRenderFns } from "./WayOfDispose.vue?vue&type=template&id=2975786a&"
import script from "./WayOfDispose.vue?vue&type=script&lang=js&"
export * from "./WayOfDispose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports